module.exports = __webpack_public_path__ + "static/media/close_icon_white.355d0682.png";